import * as PropTypes from 'prop-types';
import * as React from 'react';

const BumpBarGraphic = ({ highlightStartPercentage, highlightEndPercentage }) => {
  const highlightWidth = highlightEndPercentage - highlightStartPercentage;

  return (
    <svg
      width="200px"
      height="20px"
      viewBox="0 0 100 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask id="mask" fill="white">
        <polygon points="100 0 100 10 1.71303943e-13 10 0 9.5" />
      </mask>
      <rect
        className="bump-bar-graphic__background"
        fillRule="nonzero"
        mask="url(#mask)"
        x="0"
        y="0"
        width="100"
        height="10"
      />
      <rect
        className="bump-bar-graphic__highlight"
        fillRule="nonzero"
        mask="url(#mask)"
        x={highlightStartPercentage}
        y="0"
        width={highlightWidth}
        height="10"
      />
    </svg>
  );
};

export default BumpBarGraphic;

BumpBarGraphic.propTypes = {
  highlightStartPercentage: PropTypes.number.isRequired,
  highlightEndPercentage: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_bar_graphic.jsx